import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { IoCheckmarkOutline } from 'react-icons/io5';
import { RiErrorWarningLine } from 'react-icons/ri';
import useAuth from '../../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  isSuccess: boolean;
}

export const ChangePasswordModal = ({ isOpen, onClose, isSuccess }: ChangePasswordModalProps) => {
  const [isPasswordChanged, setIsPasswordChanged] = useState(isSuccess); 

  useEffect(() => {
    console.log("Valor de isSuccess: ", isSuccess);
    if (isSuccess) {
      setIsPasswordChanged(true); 
    }
  }, [isSuccess]);

  const { logout } = useAuth();
  const navigate = useNavigate();

  const successModalContent = (
    <ModalContent>
      <ModalHeader>
        <Box padding="l" width="fit-content" borderRadius="full" backgroundColor="primary.800" marginBottom="xl">
          <IoCheckmarkOutline color="white" fontSize="2em" />
        </Box>
        Contraseña cambiada
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Text>Tu contraseña fue cambiada con éxito. Deberás volver a iniciar sesión</Text>
      </ModalBody>
      <ModalFooter>
        <Button colorScheme="red" onClick={() => handleClose(onClose, logout, navigate)}>
          Aceptar
        </Button>
      </ModalFooter>
    </ModalContent>
  );

  const errorModalContent = (
    <ModalContent>
      <ModalHeader>
        <Box padding="l" width="fit-content" borderRadius="full" backgroundColor="destructive.700" marginBottom="xl">
          <RiErrorWarningLine color="white" fontSize="2em" />
        </Box>
        Error
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Text>Tu contraseña no fue modificada, espere un momento y vuelva a intentar</Text>
      </ModalBody>
      <ModalFooter>
        <Button colorScheme="red" onClick={onClose}>
          Cerrar
        </Button>
      </ModalFooter>
    </ModalContent>
  );

  const handleClose = (onClose: () => void, logout: () => void, navigate: any) => {
    onClose();
    logout();
    navigate('../../../login');
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      {isPasswordChanged ? successModalContent : errorModalContent}
    </Modal>
  );
};
